'use strict';

const Urls = window.Urls || {};
const ritualsStyles = require('../rituals-styles');
const productTile = require('../product-tile');
const _ = require('lodash');
const pushDataLayerEvent = require('../modules/helpers/analyticsHelper');

let mag = {};

mag = {
    // default elements
    def : {
        $window: $(window),
        $main: $('#main'),
        $magLandingBody: $('.mag-landing__body'),
        $magMenuWrapper: $('.js-m-menu__wrapper'),
        $magCategoryMenu: $('.js-m-menu'),
        $magCategoryMenuItems: $('.m-menu__category'),
        $magSubcategoryItems: $('.m-menu__subcategories'),
        $magSocialShare: $('.js-social-share'),
        magPageURL: encodeURIComponent(window.location.href),
        $headerWrapper: $('.js-header-wrapper'),
        $headerSpacer: $('.js-header-spacer')
    },

    // default settings
    settings : {
        magRootFolder : 'mag', // this setup is also in backend
        sessionStorageKey : 'magActiveFolder'
    },

    /**
     * @function
     * @description get articles from single folder
     */
    getContentFromFolder : function(folderId){
        $.ajax({
            type: 'POST',
            url: Urls.getContentFromFolder,
            data: folderId,
            success: function(data) {
                if (data) {
                    mag.def.$magLandingBody.html(data);
                    mag.events(data);
                    ritualsStyles.lazyloadInit();
                }
            }
        });
    },

    tools  : {
        getMagMenuHeight: function() {
            return mag.def.$magMenuWrapper.innerHeight();
        },

        getHeaderHeight: function() {
            return mag.def.$headerWrapper.innerHeight();
        },

        setSpacerHeight: function() {
            const height = mag.tools.getHeaderHeight() + mag.tools.getMagMenuHeight();
            mag.def.$headerSpacer.height(height);
        },

        setMagMenuTop: function() {
            const height = mag.tools.getHeaderHeight();
            mag.def.$magMenuWrapper.css('top',height);
        }
    },
    /**
     * @function
     * @description includes all events for HTML elements
     */
    events : function(){
        mag.def.$magSocialShare.find('[data-service="facebook"]').attr('href','https://www.facebook.com/sharer/sharer.php?u=' + mag.def.magPageURL);
        mag.def.$magSocialShare.find('[data-service="pinterest"]').attr('href','https://www.pinterest.com/pin/create/button/?url=' + mag.def.magPageURL);
        mag.def.$magSocialShare.find('[data-service="twitter"]').attr('href','https://twitter.com/intent/tweet/?url=' + mag.def.magPageURL);
        mag.def.$magSocialShare.find('[data-service="googleplus"]').attr('href', 'https://plus.google.com/share?url=' + mag.def.magPageURL);

        mag.def.$magCategoryMenu.unbind('click').on('click', function(){
            mag.def.$magCategoryMenu.parent().toggleClass('is--selected');
        });

        if (mag.def.$magLandingBody.length === 0){
            mag.def.$magMenuWrapper.removeClass('is--hidden');
            mag.tools.setSpacerHeight();
        }

        if (mag.def.$magLandingBody.length >= 1){
            document.addEventListener('scroll', _.throttle(function(){

                if (mag.def.$window.scrollTop() > 360) {
                   mag.def.$magMenuWrapper.removeClass('is--hidden');
                } else {
                    mag.def.$magMenuWrapper.addClass('is--hidden');
                }
            }, 100));
        }

        mag.def.$magCategoryMenuItems.add(mag.def.$magSubcategoryItems.find('li')).on('click', function (e) {
            e.stopPropagation();
            const clickedNavItem = $(e.target).text().trim();
            pushDataLayerEvent({
                event: 'menu_navigation',
                menu: 'magazine_navigation',
                menu_path: `Magazine, ${clickedNavItem}`.toLowerCase(),
                menu_text: clickedNavItem.toLowerCase(),
                menu_click: 'text'
            });
        });
    },

    /**
     * @function
     * @description main initializing function nothing else should be called from outside of 'mag' module
     */
    init : function(){
        console.log('[mag] initialized..');
        mag.events();
        mag.tools.setMagMenuTop();
        productTile.init();
        $('img.lazy').lazyload();
    }
};

module.exports = mag;
